import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import strings from '../../locale/en'
import {
  getBatchesForCourse,
  getAllBatches,
  saveBatch,
  deleteBatch
} from './api'
import {
  AddBatchForm,
  Batch,
  GetAllBatchesResponse,
  InitialState,
  SaveBatchResponse,
  UpdateFormValue
} from './types'

const initialState: InitialState = {
  isLoading: false,
  batches: [],
  pageSize: 1,
  currentPage: 0,
  formValues: {
    batchName: '',
    coachingCenterId: '',
    coachingCenterBranchId: '',
    courseId: '',
    additionalCourseId: '',
    batchStartDate: new Date(),
    batchEndDate: new Date(),
    startTiming: '',
    endTiming: null,
    batchSize: '',
    description: '',
    status: ''
  },
  formErrors: {
    batchName: '',
    coachingCenterId: '',
    coachingCenterBranchId: '',
    courseId: '',
    additionalCourseId: '',
    batchStartDate: '',
    batchEndDate: '',
    startTiming: '',
    endTiming: '',
    batchSize: '',
    description: '',
    status: ''
  },
  error: '',
  selectedBatch: null
}

export const batchSlice = createSlice({
  name: 'batch',
  initialState,
  reducers: {
    resetBatches: (state) => {
      state.batches = []
    },
    updateFormValues: (state, action: PayloadAction<UpdateFormValue>) => {
      state.formValues[action.payload.key] = action?.payload?.value
      if (state.formErrors) {
        state.formErrors[action.payload.key] = ''
      }
      if (action.payload.key === 'coachingCenterId') {
        state.formValues.coachingCenterBranchId = ''
        state.formValues.courseId = ''
        state.formValues.additionalCourseId = ''
      }
      if (action.payload.key === 'coachingCenterBranchId') {
        state.formValues.courseId = ''
      }
    },
    updateFormErrors: (state, action: PayloadAction<UpdateFormValue>) => {
      state.formErrors[action.payload.key] = action?.payload?.value
    },
    resetError: (state) => {
      state.error = ''
    },
    resetValues: (state) => {
      state.formValues = initialState.formValues
    },
    setFormValues: (state, action: PayloadAction<AddBatchForm>) => {
      state.formValues = initialState.formValues
      state.formValues = action.payload
    },
    setSelectedBatch: (state, action: PayloadAction<Batch | null>) => {
      state.selectedBatch = action.payload
    }
  },
  extraReducers: {
    [getBatchesForCourse.pending.toString()]: (state) => {
      state.isLoading = true
    },
    [getBatchesForCourse.fulfilled.toString()]: (
      state,
      action: PayloadAction<Array<Batch>>
    ) => {
      state.isLoading = false
      state.batches = action?.payload
    },
    [getBatchesForCourse.rejected.toString()]: (state) => {
      state.isLoading = false
    },
    [getAllBatches.pending.toString()]: (state) => {
      state.isLoading = true
    },
    [getAllBatches.rejected.toString()]: (state) => {
      state.isLoading = false
    },
    [getAllBatches.fulfilled.toString()]: (
      state,
      action: PayloadAction<GetAllBatchesResponse>
    ) => {
      state.isLoading = false
      state.batches = action?.payload?.batches
      state.pageSize = action?.payload?.pageSize
      state.currentPage = action?.payload?.currentPage
    },
    [saveBatch.pending.toString()]: (state) => {
      state.isLoading = true
    },
    [saveBatch.rejected.toString()]: (state) => {
      state.isLoading = false
      state.error = strings.validationMessages.batch.saveBatchFailed
    },
    [saveBatch.fulfilled.toString()]: (
      state,
      action: PayloadAction<SaveBatchResponse>
    ) => {
      state.isLoading = false
      state.formErrors = action.payload?.formErrors
      state.error = action.payload?.error || ''
    },
    [deleteBatch.pending.toString()]: (state) => {
      state.isLoading = true
    },
    [deleteBatch.rejected.toString()]: (state) => {
      state.isLoading = false
      state.error = strings.validationMessages.batch.deleteBatchFailed
    },
    [deleteBatch.fulfilled.toString()]: (state) => {
      state.isLoading = false
    }
  }
})

export default batchSlice.reducer
